import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { memo } from 'react';
import { MenuItem, Tooltip } from '@material-ui/core';
import styled from 'styled-components';
const StyledMenuItem = styled(MenuItem).withConfig({
  displayName: "Option__StyledMenuItem",
  componentId: "sc-14r9xcp-0"
})(["text-overflow:ellipsis;display:flow-root;", ""], props => props['data-focused'] ? `background-color: rgba(255, 255, 255, 0.08);` : ``);
export const Option = /*#__PURE__*/memo(props => {
  const {
    innerProps: {
      onClick,
      onMouseMove,
      onMouseOver
    }
  } = props,
        innerProps = _objectWithoutProperties(props.innerProps, ["onClick", "onMouseMove", "onMouseOver"]);

  return /*#__PURE__*/React.createElement(Tooltip, {
    title: props.label
  }, /*#__PURE__*/React.createElement(StyledMenuItem, _extends({
    component: "div",
    ref: props.innerRef,
    selected: props.isSelected,
    "data-focused": props.isFocused,
    style: {
      fontWeight: props.isSelected ? 600 : 400,
      fontSize: '1rem'
    },
    onClick: onClick
  }, innerProps), /*#__PURE__*/React.createElement(React.Fragment, null, props.children)));
});